import { render, staticRenderFns } from "./relate.vue?vue&type=template&id=051e6d2a&"
import script from "./relate.vue?vue&type=script&lang=ts&"
export * from "./relate.vue?vue&type=script&lang=ts&"
import style0 from "./relate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports